import { useState, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

const GlobalSearch = ({ onUserSelect }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const userData = useAtomValue(userInfoAtom);

  useEffect(() => {
    if (!query.trim()) {
      setResults(null);
      return;
    }

    const timer = setTimeout(() => {
      searchPortal();
    }, 300);

    return () => clearTimeout(timer);
  }, [query]);

  const searchPortal = async () => {
    setLoading(true);
    const response = await fetch(
      `${import.meta.env.VITE_APP_API_URL}/portal/search?query=${encodeURIComponent(query)}`,
      {
        headers: { Authorization: `Bearer ${userData.token}` }
      }
    );
    const data = await response.json();
    setResults(data.data);
    setLoading(false);
  };

  const handleResultClick = (result) => {
    const userId = result.CustomerID || result.userId || result.customerId;
    if (userId) {
      onUserSelect(userId);
    }
  };

  return (
    <div className="search-container">
      <div className="search-box">
        <input
          type="text"
          className="search-input"
          placeholder="Search by email, userId, customerId, subscriptionId, orderId, transactionId..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {loading && <div className="loading">Searching...</div>}

      {results && !loading && (
        <div className="search-results">
          {results.users?.length > 0 && (
            <div className="result-category">
              <div className="category-title">Users ({results.users.length})</div>
              {results.users.map((user) => (
                <div
                  key={user.CustomerID || user.userId}
                  className="result-item"
                  onClick={() => handleResultClick(user)}
                >
                  <div className="result-title">{user.customerEmail || user.email}</div>
                  <div className="result-meta">
                    Customer ID: {user.CustomerID || user.customerId || 'N/A'} <HorizontalRuleIcon className='separator-icon'/> Subscription ID: {user.SubscribtionId || user.subscriptionId || 'N/A'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {results.billingIdentities?.length > 0 && (
            <div className="result-category">
              <div className="category-title">Billing Identities ({results.billingIdentities.length})</div>
              {results.billingIdentities.map((identity) => (
                <div
                  key={identity.id}
                  className="result-item"
                  onClick={() => handleResultClick(identity)}
                >
                  <div className="result-title">{identity.email}</div>
                  <div className="result-meta">
                    Customer ID: {identity.customerId} <HorizontalRuleIcon className='separator-icon'/> Subscription ID: {identity.subscriptionId || 'N/A'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {results.webhookEvents?.length > 0 && (
            <div className="result-category">
              <div className="category-title">Webhook Events ({results.webhookEvents.length})</div>
              {results.webhookEvents.map((event) => (
                <div
                  key={event.eventId}
                  className="result-item"
                  onClick={() => handleResultClick(event)}
                >
                  <div className="result-title">{event.eventType}</div>
                  <div className="result-meta">
                    Event ID: {event.eventId} <HorizontalRuleIcon className='separator-icon'/> Status: {event.status} <HorizontalRuleIcon className='separator-icon'/> {event.timestamp ? new Date(event.timestamp).toLocaleString() : 'N/A'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {!results.users?.length && !results.billingIdentities?.length && !results.webhookEvents?.length && (
            <div className="no-results">
              <p>No results found for "{query}"</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GlobalSearch;